import { Fragment } from "react/jsx-runtime";
import EditProductForm from "../../Components/Forms/EditProductForm";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../MainPages.module.css";

const EditProductPage = () => {
    const navigate = useNavigate();
    const { slug } = useParams<{ slug: string }>();
    if (!slug) return null;

    return (
        <Fragment>
            <section className={`${styles["cd-cardSection"]} ${styles["cd-bgGlass"]}`}>
                <div className={styles["cd-cardHeader"]} >
                    <div>
                        <button
                            type="button"
                            className={styles["cd-backBtn"]}
                            onClick={() => navigate(-1)}
                        >
                            ← Go Back
                        </button>
                    </div>
                </div>
            </section>
            <EditProductForm slug={slug} />;
        </Fragment>
    );
};

export default EditProductPage;
